import * as Sentry from '@sentry/react'

const ErrorBoundary = ({ children, fallback: FallbackComponent }) => (
  <Sentry.ErrorBoundary fallback={props => <FallbackComponent {...props} />}>{children}</Sentry.ErrorBoundary>
)

export default ErrorBoundary
